/* eslint-disable no-param-reassign */
import { createImmerReducer } from '@reducers/utils/createReducer';
import { WhatsNewResponse } from '../../services/contracts/whatsNew.service';
import * as c from './types';

export interface WhatsNewState {
  loading: boolean;
  error: any;
  success: boolean;
  whatsNew: WhatsNewResponse | null;
}

const initialState: WhatsNewState = {
  loading: false,
  error: null,
  success: false,
  whatsNew: null
};

export default createImmerReducer(initialState, {
  [c.FETCH_WHATS_NEW]: (draft: WhatsNewState) => {
    draft.loading = true;
  },
  [c.FETCH_WHATS_NEW_SUCCESS]: (
    draft: WhatsNewState,
    { payload }: { payload?: WhatsNewResponse }
  ) => {
    draft.loading = false;
    draft.success = true;
    draft.whatsNew = payload ?? null;
  },

  [c.FETCH_WHATS_NEW_ERROR]: (
    draft: WhatsNewState,
    { payload }: { payload?: any }
  ) => {
    draft.loading = false;
    draft.error = payload;
  }
});
